import type { StateModel } from '../../models/state.model';

export const selectReferralAgentLink = (state: StateModel): string => {
    return state.referralAgent.referralAgentLink;
};

export const selectStateReferralAgentLink = (state: StateModel) => {
    return state.referralAgent.stateReferralAgentLink;
};
